// extracted by mini-css-extract-plugin
export default {"foto":"components_foto__Fl00a","contenedor":"components_contenedor__ST6Ov","slideUp":"components_slideUp__4LY76","letras":"components_letras__tT85r"};